import store from "~/js/store/store";
export default class Submit {
  constructor() {
    this.contents = document.querySelector('._submit');
    this.out_of_stock = this.contents.querySelector('._out_of_stock');
    this.date_of_sale = this.contents.querySelector('._date_of_sale');
    this.in_stock = this.contents.querySelector('._in_stock');
    this.arrival_notification = this.contents.querySelector('._arrival_notification');
    // this.out_of_stock_text = this.contents.querySelector('._out_of_stock_text');
    // this.out_of_notification_stock_text = this.contents.querySelector('._out_of_stock_notification_text');
    this.form = document.querySelector('#main .products-detail .form');
    this.cart = document.querySelector('cart-notification');

    this.updateOptions();
    this.updateMasterId();
    this.updateVariantInput();
    this.updateSubmitBtn();

    this.setup()
  }

  setup () {  
    store.subscribe(((mutation, state) => {
      if(mutation.type != "setSize" && mutation.type != "setColorNum")return;

      this.updateOptions();
      this.updateMasterId();
      this.updateURL();
      this.updateVariantInput();
      this.updateSubmitBtn();
      
    }));

    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
  }

  async onSubmitHandler(evt) {
    evt.preventDefault();
    //if (this.in_stock.getAttribute('aria-disabled') === 'true') return;

    //this.handleErrorMessage();

    this.in_stock.setAttribute('aria-disabled', true);
    this.in_stock.classList.add('loading');
    this.in_stock.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);
    formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
    formData.append('sections_url', window.location.pathname);
    this.cart.setActiveElement(document.activeElement);
    config.body = formData;
    /**
     * TODO: 数量制限対応
     * developer: kanehori
     */
    const variantId = evt.target.querySelector('#variants')?.value || false
    const handle = evt.target.querySelector('#handle')?.value || false
    const quantityItemLimit = evt.target.querySelector('#itemLimit')?.value || 4
    const quantityVariantLimit = evt.target.querySelector('#variantLimit')?.value || 2
    const quantityLimit = await ISSEYMIYAKE['QuantityLimit'].init(1, variantId, quantityItemLimit, quantityVariantLimit, handle)

    document.querySelector('.product-form__error-message').innerHTML = ''
    document.querySelector('.product-form__error-message-wrapper.error-message').setAttribute('hidden', true)
    if(quantityLimit?.error || quantityLimit == false) {
      document.querySelector('.product-form__error-message').innerHTML = quantityLimit?.text
      document.querySelector('.product-form__error-message-wrapper.error-message').removeAttribute('hidden')
      this.in_stock.classList.remove('loading');
      if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      if (!this.error) this.in_stock.removeAttribute('aria-disabled');
      this.in_stock.querySelector('.loading-overlay__spinner').classList.add('hidden');
      return false
    }
    // 数量制限対応 END
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          if(response.status == 422) {
            const vdata = document.querySelector('#variantData')
            const variant = JSON.parse(vdata.textContent)
            const targetVariant = variant.filter(e => e.id == variantId)
            this.handleErrorMessage(targetVariant[0]?.name + ' exceeds the quantity in stock.');
          } else {
            this.handleErrorMessage(response.description);
          }

          const soldOutMessage = this.in_stock.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.in_stock.setAttribute('aria-disabled', true);
          this.in_stock.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        }

        this.error = false;
        const quickAddModal = this.in_stock.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => { this.cart.renderContents(response) });
          }, { once: true });
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
        }
        store.dispatch("shoppingBugUpdate");
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.in_stock.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.in_stock.removeAttribute('aria-disabled');
        this.in_stock.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.contents.querySelector('.product-form__error-message-wrapper');
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }

  updateSubmitBtn() {
    this.out_of_stock.classList.remove("on");
    this.in_stock.classList.remove("on");
    this.date_of_sale.classList.remove("on");
    this.arrival_notification.classList.remove("on");
    // this.out_of_notification_stock_text.classList.remove("on");
    // this.out_of_stock_text.classList.remove("on");

    const startDate = (document.getElementById('StartJsonData').innerHTML).replace(/\s+/g, "");
    const endDate = (document.getElementById('EndJsonData').innerHTML).replace(/\s+/g, "");
    const start = new Date(startDate);
    const end = new Date(endDate);
    const today = new Date();
    
    if(today < start || end < today){
      this.in_stock.classList.remove("on");
      this.date_of_sale.classList.add("on");
    } else {
      if(this.currentVariant){
        //if available
        if(this.currentVariant.available){
          this.in_stock.classList.add("on");
          this.in_stock.disabled = false;
        }else if(!this.currentVariant.available){
          let variant = this.getVariantsOtherData().find((variant) => {
            return variant.id === this.currentVariant.id;
          })
          if(variant.is_can_restock){
            this.arrival_notification.classList.add("on");
            // this.out_of_notification_stock_text.classList.add("on");
          }else{
            // this.out_of_stock.classList.add("on");
            // this.out_of_stock_text.classList.add("on");
          }
        }
        return;
      }
      this.in_stock.classList.add("on");
    }
    this.in_stock.disabled = true;
    return;
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.contents.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const input = this.form.querySelector('input[name="id"]');
    if(this.currentVariant){
      input.value = this.currentVariant.id;
    }else{
      input.value = "";
    }
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  updateOptions() {
    const fieldsets = Array.from(this.form.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      if(Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)){
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      }else{
        return false;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(document.getElementById("variantData").textContent);
    return this.variantData;
  }

  getVariantsOtherData() {
    this.variantsOtherData = this.variantsOtherData || JSON.parse(document.getElementById("variantsOtherData").textContent);
    return this.variantsOtherData;
  }

}